const pubeurPermissions = [
  { type: 'deny', action: '*', resource: 'conversation_import_health' },
  { type: 'deny', action: 'delete', resource: 'leads' },
  { type: 'deny', action: 'delete', resource: 'events' },
  { type: 'deny', action: 'delete', resource: 'rendezvous' },
  { type: 'deny', action: ['create', 'delete'], resource: 'schools' },
  { type: 'deny', action: ['create', 'delete', 'edit'], resource: 'centers' },
  { type: 'deny', action: '*', resource: 'types' },
  { type: 'deny', action: '*', resource: 'lead_years' },
  { type: 'deny', action: '*', resource: 'lead_sources' },
  { type: 'deny', action: '*', resource: 'status_inscription' },
  { type: 'deny', action: '*', resource: 'tags' },
  { type: 'deny', action: '*', resource: 'tasks' },
  { type: 'deny', action: '*', resource: 'conversations' },
  { action: ['list', 'show', 'create', 'read', 'edit'], resource: 'leads' },
  { action: ['list', 'show', 'create', 'read', 'edit'], resource: 'rendezvous' },
  { action: ['list', 'show', 'read', 'edit'], resource: 'events' },
  { action: ['list', 'show', 'read', 'edit'], resource: 'schools' },
  { action: ['list', 'show', 'read', 'edit'], resource: 'centers' },
]

const permissions = {
  // Admin
  100: [
    { action: ['list', 'show', 'create', 'edit', 'delete', 'export'], resource: '*' },
    { action: ['read', 'write'], resource: '*' },
  ],
  // Responsable &&
  50: [
    { type: 'deny', action: '*', resource: 'conversation_import_health' },
    { type: 'deny', action: '*', resource: 'lead_years' },
    { type: 'deny', action: ['create'], resource: 'types' },
    { type: 'deny', action: '*', resource: 'lead_sources' },
    { type: 'deny', action: '*', resource: 'status_inscription' },
    { type: 'deny', action: '*', resource: 'centers' },
    { type: 'deny', action: 'delete', resource: 'profiles' },
    { action: ['list', 'show', 'create', 'edit', 'delete', 'export'], resource: '*' },
    { action: ['read', 'write'], resource: '*' },
  ],
  // Coordinateur
  30: [
    { type: 'deny', action: '*', resource: 'conversation_import_health' },
    { type: 'deny', action: '*', resource: 'lead_years' },
    { type: 'deny', action: ['create'], resource: 'types' },
    { type: 'deny', action: '*', resource: 'lead_sources' },
    { type: 'deny', action: '*', resource: 'status_inscription' },
    { type: 'deny', action: '*', resource: 'centers' },
    { type: 'deny', action: 'delete', resource: 'profiles' },
    { action: ['list', 'show', 'create', 'edit', 'delete', 'export'], resource: '*' },
    { action: ['read', 'write'], resource: '*' },
  ],
  // SDR
  20: [
    { type: 'deny', action: '*', resource: 'conversation_import_health' },
    { type: 'deny', action: 'delete', resource: 'leads' },
    { type: 'deny', action: 'delete', resource: 'rendezvous' },
    { type: 'deny', action: ['create', 'delete'], resource: 'schools' },
    { type: 'deny', action: '*', resource: 'types' },
    { type: 'deny', action: '*', resource: 'lead_years' },
    { type: 'deny', action: '*', resource: 'lead_sources' },
    { type: 'deny', action: '*', resource: 'status_inscription' },
    { type: 'deny', action: '*', resource: 'tags' },
    { type: 'deny', action: '*', resource: 'tasks' },
    { type: 'deny', action: '*', resource: 'conversations' },
    { type: 'deny', action: '*', resource: 'types' },
    { type: 'deny', action: '*', resource: 'lead_sources' },
    { type: 'deny', action: '*', resource: 'status_inscription' },
    { type: 'deny', action: '*', resource: 'centers' },
    { action: ['list', 'show', 'create', 'read', 'edit', 'export'], resource: 'leads' },
    { action: ['list', 'show', 'create', 'read', 'edit', 'export'], resource: 'rendezvous' },
    { action: ['list', 'show', 'read', 'edit'], resource: 'events' },
    { action: ['list', 'show', 'read', 'edit'], resource: 'schools' },
    { action: ['list', 'show', 'read', 'edit'], resource: 'centers' },
    { action: ['list', 'show', 'read', 'edit'], resource: 'profiles' },
  ],
  // Prof
  10: [
    { type: 'deny', action: '*', resource: 'conversation_import_health' },
    { type: 'deny', action: 'delete', resource: 'leads' },
    { type: 'deny', action: '*', resource: 'rendezvous' },
    { type: 'deny', action: '*', resource: 'types' },
    { type: 'deny', action: '*', resource: 'lead_years' },
    { type: 'deny', action: '*', resource: 'lead_sources' },
    { type: 'deny', action: '*', resource: 'status_inscription' },
    { type: 'deny', action: '*', resource: 'types' },
    { type: 'deny', action: '*', resource: 'lead_years' },
    { type: 'deny', action: '*', resource: 'lead_sources' },
    { type: 'deny', action: '*', resource: 'tags' },
    { type: 'deny', action: '*', resource: 'tasks' },
    { type: 'deny', action: '*', resource: 'conversations' },
    { type: 'deny', action: '*', resource: 'types' },
    { type: 'deny', action: '*', resource: 'lead_sources' },
    { type: 'deny', action: '*', resource: 'centers' },
    { action: ['list', 'show', 'edit'], resource: '*' },
    { action: ['read', 'write'], resource: '*' },
  ],
  // Pubeur
  0: pubeurPermissions,
  // hippocast
  '-3': [
    { action: ['list'], resource: 'hippocast_summary' },
    { action: ['list'], resource: 'centers' },
  ],
  '-5': [
    { action: ['list'], resource: 'conversations' },
    { action: ['list'], resource: 'centers' },
    { action: ['list'], resource: 'leads' },
    { action: ['list'], resource: 'profiles' },
  ]
}

export default permissions
